<template>
  <div class="mainBox">
      <h2 class="main">用户反馈</h2>
     
      <el-form ref="form" :rules="rules" :model="form" label-width="80px" >
      <el-form-item label="姓名"  prop="username"><!-- form-item用于显示关联的文件 -->
        <el-input v-model="form.username" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input  v-model="form.email" maxlength="30" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="手机号码"  prop="cellphone">
        <el-input  v-model="form.cellphone" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="留言内容" prop="content">
           <el-input type="textarea" rows="15" v-model="form.content" maxlength="200" show-word-limit></el-input>
         </el-form-item>
       <el-form-item>
        <el-button type="primary" @click="onSubmit">留言</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
  import axios from "axios";
  export default {
    data() {
      return {
        form: {
          username: '',
          email:'',
          cellphone:'',
          content:''
        },
        rules:{
          username:[
                { required: true, message: '请输入姓名', trigger: 'blur' },
                { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
            ],
            email:[
                { required: true, message: '请输入电子邮箱', trigger: 'blur' },
                { type: 'email', required: true, message: '必须为规范的电子邮箱地址', trigger: 'change' }
            ],
            cellphone:[
                { required: true, message: '请输入联系号码', trigger: 'blur' },
            ],
            content:[
                { required: true, message: '请输入留言内容', trigger: 'blur' },
                { min: 10, max: 200, message: '长度在 10 到 200 个字符', trigger: 'blur' }
            ],
        },
      }
    },
    methods: {
      onSubmit() {
        this.$refs.form.validate((valid)=>{
              if (valid){
                let formData = {
                username: this.form.username,
                email: this.form.email,
                cellphone: this.form.cellphone,
                content: this.form.content,
              };
              axios.post(this.COMMON.httpUrl + "/api/message/save", formData).then((res) => {
                  if(res.data.code==200){
                    this.$refs.form.resetFields();
                    this.$message({
                      message: '提交成功！',
                      type: 'success'
                    });
                  }
                });
              }else{
                this.$message.error('提交失败！')
                return false;
              }
            })


        

      }
    }
  }
</script>
<style>
.el-button--primary{background: darkred; border-color: darkred;}
/* .el-input,.el-textarea {
  width: 700px;
} */
</style>
